import { render, staticRenderFns } from "./addnews.vue?vue&type=template&id=051bbf38&scoped=true&"
import script from "./addnews.vue?vue&type=script&lang=js&"
export * from "./addnews.vue?vue&type=script&lang=js&"
import style0 from "./addnews.vue?vue&type=style&index=0&id=051bbf38&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051bbf38",
  null
  
)

export default component.exports